import EmployeeEntryTable from "./EmployeeEntryTable";

export default function EmployeeHistoryRow({
  employee,
  isOpen,
  onToggle,
}) {
  return (
    <>
      {/* ================= SUMMARY ROW ================= */}
      <tr className="bg-gray-50 align-middle">
        <td className="px-4 py-3 font-semibold whitespace-nowrap">
          {employee.employee_name}
        </td>

        <td className="px-4 py-3 text-center">
          <span
            className="badge bg-primary"
            style={{ padding: "4px", borderRadius: "12px", color: "#fff" }}
          >
            {employee.entry_count}
          </span>
        </td>

        <td className="px-4 py-3 text-center">
          £{employee.totals.gross_pay.toFixed(2)}
        </td>

        <td className="px-4 py-3 text-center">
          £{employee.totals.tax.toFixed(2)}
        </td>

        <td className="px-4 py-3 text-center">
          £{employee.totals.employee_nics.toFixed(2)}
        </td>

        <td className="px-4 py-3 text-center">
          £{employee.totals.employer_nics.toFixed(2)}
        </td>

        <td className="px-4 py-3 text-center">
          £{employee.totals.net_pay.toFixed(2)}
        </td>

        <td className="px-4 py-3 text-center">
          <button
            onClick={onToggle}
            className="btn btn-sm btn-outline-primary"
            title={isOpen ? "Hide details" : "View details"}
          >
            {isOpen ? "▼" : "▶"}
          </button>
        </td>
      </tr>

      {/* ================= EXPANDED DETAILS ================= */}
      {isOpen && (
        <tr>
          {/* ⚠️ Ensure colSpan matches total column count */}
          <td colSpan={8} className="bg-light p-3">
            <div className="bg-white border rounded p-3">
              <h6 className="mb-3 fw-semibold">
                Employee Breakdown – {employee.employee_name}
              </h6>

              <div style={{ overflowX: "auto" }}>
                <EmployeeEntryTable entries={employee.entries || []} />
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}
